import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HelpTicket } from '@cots/common/resources/helpTicket';
import { UserService } from '@cots/common/services/user.service';

@Component({
  selector: 'help-ticket-detail',
  templateUrl: './help-ticket-detail.component.html',
  styleUrls: ['./help-ticket-detail.component.less']
})
export class HelpTicketDetailComponent implements OnInit {

  @Input() record: HelpTicket;
  @Output() exit = new EventEmitter<void>();
  @Output() markClosed = new EventEmitter<void>();
  constructor(
    public userSvc: UserService
  ) {
  }

  ngOnInit(): void {

  }

}
